import { FC } from 'react';

import { Link } from '@inertiajs/react';

import { BlogPost } from '../../types';
import { formatDate } from '../../utils';

type RelatedPostsProps = {
    posts: BlogPost[];
};

export const RelatedPosts: FC<RelatedPostsProps> = ({ posts }) => {
    if (!posts?.length) return null;

    if (posts.length === 0) {
        return null;
    }

    return (
        <aside className="lg:sticky lg:top-24 lg:self-start">
            <h2 className="mb-4 text-sm font-semibold">Інші статті</h2>

            <div className="space-y-3">
                {posts.map((post) => (
                    <Link
                        key={post.id}
                        href={post.url_path}
                        className="block rounded-2xl border bg-card p-3 transition-colors hover:border-primary/40"
                    >
                        {post.cover_image_url && (
                            <img
                                src={post.cover_image_url}
                                alt={post.title}
                                className="mb-3 h-full w-full rounded-2xl object-cover"
                            />
                        )}

                        <div className="mb-2 flex items-center justify-between gap-2 text-xs text-muted-foreground">
                            <time dateTime={post.published_at}>
                                {formatDate(post.published_at)}
                            </time>
                            <div className="flex flex-wrap justify-end gap-1">
                                {(post.tags || []).map((tag) => (
                                    <span
                                        key={tag}
                                        className="rounded-full bg-slate-200 px-2 py-0.5 text-slate-700"
                                    >
                                        #{tag}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <h3 className="line-clamp-2 text-sm leading-snug font-medium">
                            {post.title}
                        </h3>
                    </Link>
                ))}
            </div>
        </aside>
    );
};
